import React from "react";
import RenderCaixa from "./renderCaixa/renderCaixa";
import "./CaixaDaAguaPainel.css";  

export default function CaixaDaAguaPainel({ caixas = [] }) {

  if (!caixas.length) return (
    <p className="msgVaziaCaixas">Sem alarme de Caixa D'água</p>
  );

  return (
    <div className="painelCaixas">
      {caixas.map((cx) => (
        <RenderCaixa
          key={cx.id}
          desc={cx.desc}
          niveis={cx.niveis}
        />
      ))}
    </div>
  );
}